import React, { Component } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import LeadManagementHome from '../components/LeadManagement/LeadManagementHome';



const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
          educationalClasses {
            id
            class
          }
        classes{
            id
            class
        }
        exams{
            id
            exam
            exam_subjects{
                subject_id
              }
        }
          globalBranches{
            id
            branch_name
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
          }
          globalPackages {
            id
            package_name
            exams_covered
          }
          globalCategories {
            id
            category_name
            package_id
          }
          offlineExamSubjects{
            id
            subject
          }
    }
}

`;


const FETCH_NEXT_LEVEL_USER_AND_EMPLOYEE = gql`
  query($institute_id: Int!,$branch_id: Int!,$head_employee_id: Int!,$is_grouping: Boolean!) {
    getNextLevelUserAndEmployeeDetails(institute_id: $institute_id,branch_id: $branch_id,head_employee_id: $head_employee_id,is_grouping: $is_grouping) {
      level_id
      employee_id
      employee_name
      next_level_emp
      status_details
    }
  }
`;

const FETCH_LEAD_TASK_STATUS_DETAILS = gql`
  query($employee_id: Int!) {
    getLeadTaskStatusDetails(employee_id: $employee_id) {
        lead_status_details
    }
  }
`;

class LeadManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const getNextLevelUserAndEmployeeDetails = this.props.getNextLevelUserAndEmployeeDetails;
        const loading2 = getNextLevelUserAndEmployeeDetails.loading;
        const error2 = getNextLevelUserAndEmployeeDetails.error
        console.log("getNewEducationalStudents", getNextLevelUserAndEmployeeDetails);

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        const getLeadTaskStatusDetails = this.props.getLeadTaskStatusDetails;
        const loading3 = getLeadTaskStatusDetails.loading;
        const error3 = getLeadTaskStatusDetails.error

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            {

                                loading1 || loading2 || loading3 ?
                                    (
                                        <Container><Row className="my-3">
                                            <Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row></Container>
                                    ) : (

                                        <LeadManagementHome
                                            globals={globals.globals}
                                            getNextLevelUserAndEmployeeDetails={getNextLevelUserAndEmployeeDetails.getNextLevelUserAndEmployeeDetails}
                                            getLeadTaskStatusDetails={getLeadTaskStatusDetails.getLeadTaskStatusDetails}

                                        />
                                    )



                            }

                        </Container>

                    </div>
                    <Footer />
                </div>
            </div>)
    }
}

export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))

                    }
                }), name: "globals"
            }),

        graphql(FETCH_NEXT_LEVEL_USER_AND_EMPLOYEE, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(Cookies.get("branch_id")),
                    head_employee_id: parseInt(Cookies.get("id")),
                    is_grouping: true,
                },
            }),
            name: "getNextLevelUserAndEmployeeDetails",
        }),

        graphql(FETCH_LEAD_TASK_STATUS_DETAILS, {
            options: (props) => ({
                variables: {
                    employee_id: parseInt(Cookies.get("id")),
                },
            }),
            name: "getLeadTaskStatusDetails",
        }),

    )
        (LeadManagement));